var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "overflow-hidden h-100 w-100 p-3" }, [
      _c(
        "div",
        {
          staticClass: "position-relative h-100 w-100",
          attrs: { id: "canvas-container-main" },
        },
        [
          _c("canvas", { attrs: { id: "job-canvas" } }),
          _vm._v(" "),
          _c("canvas", { attrs: { id: "cursor" } }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }